export default "__VITE_ASSET__BvS3S_Gt__"